import { Col } from 'antd'
import { useTranslation } from 'react-i18next'
import { getEmployeeFullName, getReviewerFullName } from '../../../shared/employeeUtil'
import { Meeting } from '../../../types'
import PerFlexRow from '../FlexRow'
import PerIcon from '../Icon'
import { IconCard } from '../IconCard'
import PerText from '../Text'

export interface MeetingStatusModalPreparationProps {
  meeting?: Meeting
}

export const MeetingStatusModalPreparation = ({ meeting }: MeetingStatusModalPreparationProps): JSX.Element | null => {
  const { t } = useTranslation()

  if (!meeting) {
    return null
  }

  const employeePrepared = meeting.employeePrepared
  const reviewerPrepared = meeting.managerPrepared

  return (
    <>
      <Col span={8}>
        <IconCard icon="user_fill">
          <PerFlexRow justify="center">
            <PerText fontSize="m" fontWeight="bold">
              {t('appraisalStatusModal.employee')}
            </PerText>
          </PerFlexRow>
          <PerFlexRow mt="xxxs" justify="center">
            <PerText fontSize="s" testId="preparation-employee-name">
              {getEmployeeFullName(meeting.employee)}
            </PerText>
          </PerFlexRow>
          <PerFlexRow mt="l" mb="s" justify="center" align="bottom">
            <PerIcon name={employeePrepared ? 'check_stroke' : 'warning_fill'} color={employeePrepared ? 'success' : 'error'} />
            <PerText color={employeePrepared ? 'success' : 'error'} fontSize="l" mr="xs" ml="xs" testId="preparation-employee-status">
              {employeePrepared ? t('appraisalStatusModal.prepared') : t('appraisalStatusModal.notPrepared')}
            </PerText>
          </PerFlexRow>
        </IconCard>
      </Col>
      <Col span={8}>
        <IconCard icon="user_fill">
          <PerFlexRow justify="center">
            <PerText fontSize="m" fontWeight="bold">
              {t('appraisalStatusModal.reviewer')}
            </PerText>
          </PerFlexRow>
          <PerFlexRow mt="xxxs" justify="center">
            <PerText fontSize="s" testId="preparation-reviewer-name">
              {getReviewerFullName(meeting.reviewer)}
            </PerText>
          </PerFlexRow>
          <PerFlexRow mt="l" mb="s" justify="center" align="bottom">
            <PerIcon name={reviewerPrepared ? 'check_stroke' : 'warning_fill'} color={reviewerPrepared ? 'success' : 'error'} />
            <PerText color={reviewerPrepared ? 'success' : 'error'} fontSize="l" mr="xs" ml="xs" testId="preparation-reviewer-status">
              {reviewerPrepared ? t('appraisalStatusModal.prepared') : t('appraisalStatusModal.notPrepared')}
            </PerText>
          </PerFlexRow>
        </IconCard>
      </Col>
    </>
  )
}
